import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { UserService } from '../../Services/userservice.service';
import { MustMatch } from './Validators/match.validator';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {


  formregistro: UntypedFormGroup;
  submitted = false;
  super=false;
  disabledButton=true;

  get f() { return this.formregistro.controls; }
  constructor(private formBuilder: UntypedFormBuilder, private userService: UserService, private _snackBar: MatSnackBar,    private router: Router) { }

  ngOnInit(): void {

    this.onPropagar();

    // console.log('Este es el registro ');
    
    this.super=this.userService.is_super()

    if(!this.super){
      this.userService.logout()
      this.router.navigate(['login']);
      
    }


    this.formregistro = this.formBuilder.group({
      username: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      pass: ['', Validators.required],
      confirm_pass: ['', Validators.required],
      roles: ['', Validators.required],
    }, {
      validator: MustMatch('pass', 'confirm_pass')
    });

  }

  submit(values: any) {

    this.submitted = true;
    this.disabledButton = false;

    if (this.formregistro.invalid) {
      console.log("invalido");
      return;
    }

    let data={
      username:values.username, 
      email:values.email,
      password:values.pass,
      roles:[{id:values.roles, type:"foreignid"}]
    }
    this.userService.registro(data).subscribe( (res:any) => {
        console.log(res);
        // this._snackBar.open("Usuario creado correctamente", "Cerrar");
        Swal.fire(
          'Creación de usuario',
          `Usuario ${values.username} creado correctamente`,
          'success'
        )
        this.router.navigate(['list-users'])
      }, ( err:any ) => {
        this.disabledButton = true;
        console.log("ERROR de registro", err);
        console.log(err.error.message);

        if( err.status == 403 ){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: "El usuario ya existe en HubSpot, y no tiene permisos para acceder a este sitio",
          });
          return
        }else if(err.status == 429){
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: err.error,
          })
          return
        }else if (<any>err.status === 401) {
          this.router.navigate(['login']);
        }else {
          Swal.fire({
            icon: 'error',
            title: 'Oops...',
            text: 'Ocurrio un error al registrar al usuario',
          })
        }
      }
    )

  }

  onPropagar() {
    this.userService.emitChange("Crear Usuario")
  }

}


